"use client";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/components/ui/alert-dialog";
import { Button } from "@/shared/components/ui/button";
import { useTranslation } from "react-i18next";

type DeleteProps = {
  isOpen: boolean;
  showActionToggle: (open: boolean) => void;
  confirmFunction: () => void;
};

export default function DeleteDialog({
  isOpen,
  showActionToggle,
  confirmFunction,
}: DeleteProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={isOpen} onOpenChange={showActionToggle}>
      <AlertDialogContent
        style={{
          zIndex: 999,
        }}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>{t("delete-title")}</AlertDialogTitle>
          <AlertDialogDescription>
            <b>{t("delete-description")}</b>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("cancel")}</AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={() => {
              showActionToggle(false);
              confirmFunction();
            }}
          >
            {t("delete")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
